import { Navigate } from 'react-router-dom';

import { AuthGuard } from '@managers/auth-guard';
import { ProjectRouteGuard } from '@managers/project-route-guard';
import { PROJECT_NAME } from '@config/projects';

import { MainLayout } from '@widgets/layout/main-layout';

import { appLazily, Loadable } from '@kit/loadable';

import { ROOT, ROUTES } from './routes';

const DashboardScene = Loadable(
  appLazily(() => import('@scenes/dashboard')).DashboardScene
);
const UsersListScene = Loadable(
  appLazily(() => import('@scenes/users-list')).UsersListScene
);
const UserAccountProfileScene = Loadable(
  appLazily(() => import('@scenes/user-account-profile'))
    .UserAccountProfileScene
);
const AffiliatesScene = Loadable(
  appLazily(() => import('@scenes/affiliates')).AffiliatesScene
);
const AffiliatesProfileTransferScene = Loadable(
  appLazily(() => import('@scenes/affiliates-profile-transfer'))
    .AffiliatesProfileTransferScene
);
const AffiliatesOnlineOfflineAccessScene = Loadable(
  appLazily(() => import('@scenes/affiliates-online-offline-access'))
    .AffiliatesOnlineOfflineAccessScene
);
const PaymentsScene = Loadable(
  appLazily(() => import('@scenes/payments')).PaymentsScene
);
const WithdrawalsScene = Loadable(
  appLazily(() => import('@scenes/withdrawals')).WithdrawalsScene
);
const SystemScene = Loadable(
  appLazily(() => import('@scenes/system')).SystemScene
);
const PhotosScene = Loadable(
  appLazily(() => import('@scenes/photos')).PhotosScene
);
const AdministratorsScene = Loadable(
  appLazily(() => import('@scenes/administrators')).AdministratorsScene
);
const AdministratorProfileCreateScene = Loadable(
  appLazily(() => import('@scenes/administrator-profile-create'))
    .AdministratorProfileCreateScene
);
const AdministratorProfileScene = Loadable(
  appLazily(() => import('@scenes/administrator-profile'))
    .AdministratorProfileScene
);
const ReportsScene = Loadable(
  appLazily(() => import('@scenes/reports')).ReportsScene
);

export const AppRoutes = {
  path: ROOT,
  element: (
    <AuthGuard>
      <MainLayout />
    </AuthGuard>
  ),
  children: [
    {
      path: ROOT,
      element: <Navigate replace to={ROUTES.dashboard} />,
    },
    {
      path: ROUTES.dashboard,
      element: <DashboardScene />,
    },
    {
      path: ROUTES.users,
      element: <UsersListScene />,
    },
    {
      path: ROUTES.user,
      element: <UserAccountProfileScene />,
    },
    {
      path: ROUTES.affiliates,
      element: <AffiliatesScene />,
    },
    {
      path: ROUTES.affiliatesProfileTransfer,
      element: <AffiliatesProfileTransferScene />,
    },
    {
      path: ROUTES.affiliatesOnlineOfflineAccess,
      element: (
        <ProjectRouteGuard
          allowedProjects={[PROJECT_NAME.FFD]}
          redirectTo={ROUTES.affiliates}
        >
          <AffiliatesOnlineOfflineAccessScene />
        </ProjectRouteGuard>
      ),
    },
    {
      path: ROUTES.administrators,
      element: <AdministratorsScene />,
    },
    {
      path: ROUTES.createAdministrator,
      element: <AdministratorProfileCreateScene />,
    },
    {
      path: ROUTES.administrator,
      element: <AdministratorProfileScene />,
    },
    {
      path: ROUTES.payments,
      element: <PaymentsScene />,
    },
    {
      path: ROUTES.withdrawals,
      element: <WithdrawalsScene />,
    },
    {
      path: ROUTES.photos,
      element: <PhotosScene />,
    },
    {
      path: ROUTES.reports,
      element: <ReportsScene />,
    },
    {
      path: ROUTES.system,
      element: <SystemScene />,
    },
  ],
};
